import appDataSliceReducer from "./features/appData/appDataSlice";
import { configureStore } from "@reduxjs/toolkit";
import { loadState } from "../utils/localStorage";

const preloadedState = loadState();

const store = configureStore({
  preloadedState: preloadedState,
  reducer: {
    appData: appDataSliceReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
